import React from "react";
import LegalDocument from "../../components/legal/LegalDocument";
import { useCurrency } from "../../context/CurrencyContext";

export default function HostTermsFull() {
  const { settings } = useCurrency();
  return (
    <LegalDocument
      eyebrow="Legal"
      title="Host Terms & Conditions"
      text={settings?.legal_host_terms}
      loading={!settings?.legal_host_terms}
      relatedLinks={[
        { to: "/legal/terms/renter", label: "Renter Terms & Conditions" },
        { to: "/legal/privacy", label: "Privacy Policy" },
      ]}
    />
  );
}
